import React from 'react';
import classnames from 'classnames';
import { string } from 'prop-types';
import { TYPE } from './utils/constants';
import { getContentStyles } from './utils';

import './style.scss';

const Badge = ({ className, type }) => {
    const { content, classNameStyle } = getContentStyles(type);
    const classNames = classnames(
        className,
        classNameStyle,
        'badge text-semi-bold'
    );

    if (!content) {
        return null;
    }

    return (
        <div className={classNames}>
            {content}
        </div>
    );
};

Badge.TYPE = TYPE;

Badge.propTypes = {
    className: string,
    type: string
};

export default Badge;
